import React from "react";
import { connect } from "react-redux";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import language from "../../language";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { getStorage } from "../../utils/storage";
// eslint-disable-next-line no-unused-vars

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const DISEASE_OPTIONS = [
  { label: "Syphilis", value: "SYPHILIS" },
  { label: "HIV", value: "HIV" },
  { label: "HBsAg", value: "HBSAG" },
  { label: "HCV", value: "HCV" },
];

const RESULT_CONDITION_OPTIONS = [
  { label: "Reactive", value: "reactive" },
  { label: "Non-Reactive", value: "nonreactive" },
  { label: "Gray Zone", value: "grayZone" },
  { label: "Reactive or Gray Zone", value: "reactive_or_grayZone" },
  { label: "Any", value: "any" },
  { label: "Mismatch", value: "mismatch" },
  { label: "Discrepancy", value: "discrepancy" },
  { label: "Positive", value: "positive" },
  { label: "Negative", value: "negative" },
  { label: "Pending", value: "pending" },
  { label: "Inconclusive", value: "inconclusive" },
];

const DONATION_STATUS_OPTIONS = [
  { label: "Accepted", value: "accepted" },
  { label: "Blocked", value: "blocked" },
  { label: "Temporarily Blocked", value: "temporarily_blocked" },
  { label: "Quarantined", value: "quarantined" },
  { label: "Product Restricted", value: "product_restricted" },
];

const DONOR_STATUS_OPTIONS = [
  { label: "Active", value: "active" },
  { label: "Permanently Blocked", value: "permanently_blocked" },
  { label: "Temporarily Blocked", value: "temporarily_blocked" },
];

const BLOCK_CLASSIFICATION_OPTIONS = [
  { label: "-- None --", value: "none" },
  { label: "Donation Only", value: "donation_only" },
  { label: "Permanent", value: "permanent" },
  { label: "Temporary", value: "temporary" },
];

const ASSAY_ROLE_OPTIONS = [
  { label: "Screening Assay", value: "screening_assay" },
  { label: "Repeat Assay", value: "repeat_assay" },
  { label: "Confirmatory Assay", value: "confirmatory_assay" },
];

const STAGE_OPTIONS = [
  { label: "Initial Screen", value: "initial_screen" },
  { label: "Repeat Screen", value: "repeat_screen" },
  { label: "Confirmation", value: "confirmation" },
];

const TEST_TYPE_OPTIONS = [
  { label: "Blood Grouping", value: "bloodGrouping" },
  { label: "Serology", value: "serology" },
];

const REPEAT_RULE_OPTIONS = [
  { label: "None", value: "none" },
  { label: "Once", value: "once" },
  { label: "Twice", value: "twice" },
  { label: "Until Discordant", value: "until_discordant" },
];

const YES_NO_OPTIONS = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

class NewTestAssayRule extends React.Component {
  state = {
    code: "",
    name: "",
    description: "",
    disease: null,
    assayRole: null,
    stage: null,
    testType: { label: "Serology", value: "serology" },
    testCode: "",
    testName: "",
    reactiveCutoff: "",
    grayZoneCutoff: "",
    blockDonor: null,
    blockDonation: null,
    requiresConfirmation: null,
    confirmationType: "",
    repeatRequired: null,
    repeatRule: null,
    displayMeaning: "",
    nextAction: "",
    isActive: { label: "Active", value: true },
    sortOrder: "",
    // New fields
    bloodGroupScenario: "",
    resultCondition: null,
    donationStatus: null,
    donorStatus: null,
    actionRequired: "",
    blockClassification: null,
    nextActions: "",
    mandatoryActions: null,
    quarantineDonation: null,
    requiresInvestigation: null,
    productRestrictions: "",
    error: {},
    isSubmitting: false,
  };

  componentDidMount = async () => {
    if (this.props._id && this.props._id !== "") {
      this.setState({
        code: this.props.code || "",
        name: this.props.name || "",
        description: this.props.description || "",
        disease: this.props.disease
          ? {
              label: this.props.disease,
              value: this.props.disease,
            }
          : null,
        assayRole: this.props.assayRole
          ? {
              label: this.formatLabel(this.props.assayRole),
              value: this.props.assayRole,
            }
          : null,
        stage: this.props.stage
          ? {
              label: this.formatLabel(this.props.stage),
              value: this.props.stage,
            }
          : null,
        testType: this.props.testType
          ? {
              label:
                this.props.testType === "bloodGrouping"
                  ? "Blood Grouping"
                  : "Serology",
              value: this.props.testType,
            }
          : { label: "Serology", value: "serology" },
        testCode: this.props.testCode || "",
        testName: this.props.testName || "",
        reactiveCutoff: this.props.reactiveCutoff || "",
        grayZoneCutoff: this.props.grayZoneCutoff || "",
        blockDonor:
          this.props.blockDonor != null
            ? {
                label: this.props.blockDonor ? "Yes" : "No",
                value: this.props.blockDonor,
              }
            : null,
        blockDonation:
          this.props.blockDonation != null
            ? {
                label: this.props.blockDonation ? "Yes" : "No",
                value: this.props.blockDonation,
              }
            : null,
        requiresConfirmation:
          this.props.requiresConfirmation != null
            ? {
                label: this.props.requiresConfirmation ? "Yes" : "No",
                value: this.props.requiresConfirmation,
              }
            : null,
        confirmationType: this.props.confirmationType || "",
        repeatRequired:
          this.props.repeatRequired != null
            ? {
                label: this.props.repeatRequired ? "Yes" : "No",
                value: this.props.repeatRequired,
              }
            : null,
        repeatRule: this.props.repeatRule
          ? {
              label: this.formatLabel(this.props.repeatRule),
              value: this.props.repeatRule,
            }
          : null,
        displayMeaning: this.props.displayMeaning || "",
        nextAction: this.props.nextAction || "",
        isActive:
          this.props.isActive != null
            ? {
                label: this.props.isActive ? "Active" : "Inactive",
                value: this.props.isActive,
              }
            : { label: "Active", value: true },
        sortOrder: this.props.sortOrder || "",
        // New fields
        bloodGroupScenario: this.props.bloodGroupScenario || "",
        resultCondition: this.props.resultCondition
          ? { label: this.formatLabel(this.props.resultCondition), value: this.props.resultCondition }
          : null,
        donationStatus: this.props.donationStatus
          ? { label: this.formatLabel(this.props.donationStatus), value: this.props.donationStatus }
          : null,
        donorStatus: this.props.donorStatus
          ? { label: this.formatLabel(this.props.donorStatus), value: this.props.donorStatus }
          : null,
        actionRequired: this.props.actionRequired || "",
        blockClassification: this.props.blockClassification
          ? { label: this.formatLabel(this.props.blockClassification), value: this.props.blockClassification }
          : null,
        nextActions: this.props.nextActions
          ? (Array.isArray(this.props.nextActions)
              ? this.props.nextActions.join(", ")
              : this.props.nextActions)
          : "",
        mandatoryActions:
          this.props.mandatoryActions != null
            ? { label: this.props.mandatoryActions ? "Yes" : "No", value: this.props.mandatoryActions }
            : null,
        quarantineDonation:
          this.props.quarantineDonation != null
            ? { label: this.props.quarantineDonation ? "Yes" : "No", value: this.props.quarantineDonation }
            : null,
        requiresInvestigation:
          this.props.requiresInvestigation != null
            ? { label: this.props.requiresInvestigation ? "Yes" : "No", value: this.props.requiresInvestigation }
            : null,
        productRestrictions: this.props.productRestrictions
          ? JSON.stringify(this.props.productRestrictions, null, 2)
          : "",
      });
    }
  };

  formatLabel(value) {
    return String(value)
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  onChangeText(field, e) {
    let { error } = this.state;
    delete error[field];

    const value = e && e?.target ? e?.target?.value : e;

    this.setState({
      [field]: value,
      error,
    });
  }

  validateForm() {
    let { error, code, name, disease, assayRole, stage, testType } = this.state;

    if (!code || code === "") {
      error.code = language[this.props.defaultLanguage].code_required;
    }

    if (!name || name === "") {
      error.name = language[this.props.defaultLanguage].name_required;
    }

    if (!disease && testType?.value !== "bloodGrouping") {
      error.disease = language[this.props.defaultLanguage].field_required;
    }

    if (!assayRole) {
      error.assayRole = language[this.props.defaultLanguage].field_required;
    }

    if (!stage) {
      error.stage = language[this.props.defaultLanguage].field_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({ isSubmitting: true });

      let {
        _id,
        code,
        name,
        description,
        disease,
        assayRole,
        stage,
        testType,
        testCode,
        testName,
        reactiveCutoff,
        grayZoneCutoff,
        blockDonor,
        blockDonation,
        requiresConfirmation,
        confirmationType,
        repeatRequired,
        repeatRule,
        displayMeaning,
        nextAction,
        isActive,
        sortOrder,
        // New fields
        bloodGroupScenario,
        resultCondition,
        donationStatus,
        donorStatus,
        actionRequired,
        blockClassification,
        nextActions,
        mandatoryActions,
        quarantineDonation,
        requiresInvestigation,
        productRestrictions,
      } = this.state;

      const user = await getStorage();

      let requestBody = {
        code: code?.toUpperCase(),
        name,
        description,
        disease: disease?.value,
        assayRole: assayRole?.value,
        stage: stage?.value,
        testType: testType?.value,
        testCode,
        testName,
        reactiveCutoff:
          reactiveCutoff !== "" ? Number(reactiveCutoff) : undefined,
        grayZoneCutoff:
          grayZoneCutoff !== "" ? Number(grayZoneCutoff) : undefined,
        blockDonor: blockDonor?.value,
        blockDonation: blockDonation?.value,
        requiresConfirmation: requiresConfirmation?.value,
        confirmationType,
        repeatRequired: repeatRequired?.value,
        repeatRule: repeatRule?.value,
        displayMeaning,
        nextAction,
        isActive: isActive?.value,
        sortOrder: sortOrder !== "" ? Number(sortOrder) : undefined,
        // New fields
        ruleType: testType?.value === "bloodGrouping" ? "bloodGrouping" : "serology",
        bloodGroupScenario: bloodGroupScenario || undefined,
        resultCondition: resultCondition?.value,
        donationStatus: donationStatus?.value,
        donorStatus: donorStatus?.value,
        actionRequired: actionRequired || undefined,
        blockClassification: blockClassification?.value,
        nextActions: nextActions
          ? nextActions.split(",").map((s) => s.trim()).filter(Boolean)
          : undefined,
        mandatoryActions: mandatoryActions?.value,
        quarantineDonation: quarantineDonation?.value,
        requiresInvestigation: requiresInvestigation?.value,
        productRestrictions: productRestrictions
          ? (() => {
              try {
                return JSON.parse(productRestrictions);
              } catch (e) {
                return undefined;
              }
            })()
          : undefined,
      };

      let url = `${API_URL}/testAssayRule`;
      let method = "POST";

      if (_id && _id !== "") {
        method = "PUT";
        requestBody.id = _id;
      }

      const options = {
        method,
        url,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        data: requestBody,
      };

      axios(options)
        .then((data) => {
          this.setState({ isSubmitting: false });

          toastMessage(
            "success",
            method === "PUT"
              ? language[this.props.defaultLanguage]
                  .success_update_test_assay_rule
              : language[this.props.defaultLanguage]
                  .success_create_test_assay_rule,
          );

          this.props.getData(true);
          this.props.handleCloseModal();
        })
        .catch((error) => {
          toastMessage("error", error);
          this.setState({ isSubmitting: false });
        });
    }
  };

  render() {
    return (
      <div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <Input
                placeholder={
                  language[this.props.defaultLanguage].code_placeholder
                }
                label={language[this.props.defaultLanguage].code}
                required
                value={this.state.code?.toUpperCase()}
                onChange={(e) => this.onChangeText("code", e)}
                error={this.state.error.code}
              />
            </div>
            <div className="col-md-12">
              <Input
                placeholder={
                  language[this.props.defaultLanguage].name_placeholder
                }
                label={language[this.props.defaultLanguage].name}
                required
                value={this.state.name}
                onChange={(e) => this.onChangeText("name", e)}
                error={this.state.error.name}
              />
            </div>
            <div className="col-md-12">
              <Input
                placeholder={
                  language[this.props.defaultLanguage].description_placeholder
                }
                label={language[this.props.defaultLanguage].description}
                value={this.state.description}
                onChange={(e) => this.onChangeText("description", e)}
                error={this.state.error.description}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={DISEASE_OPTIONS}
                placeholder={language[this.props.defaultLanguage].disease}
                label={language[this.props.defaultLanguage].disease}
                required
                value={this.state.disease}
                onChange={(e) => this.onChangeText("disease", e)}
                error={this.state.error.disease}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={ASSAY_ROLE_OPTIONS}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].assay_role}
                required
                value={this.state.assayRole}
                onChange={(e) => this.onChangeText("assayRole", e)}
                error={this.state.error.assayRole}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={STAGE_OPTIONS}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].stage}
                required
                value={this.state.stage}
                onChange={(e) => this.onChangeText("stage", e)}
                error={this.state.error.stage}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={TEST_TYPE_OPTIONS}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].test_type}
                value={this.state.testType}
                onChange={(e) => this.onChangeText("testType", e)}
                error={this.state.error.testType}
              />
            </div>
            <div className="col-md-6">
              <Input
                placeholder="e.g. SYPH_IS"
                label={language[this.props.defaultLanguage].test_code}
                value={this.state.testCode}
                onChange={(e) => this.onChangeText("testCode", e)}
                error={this.state.error.testCode}
              />
            </div>
            <div className="col-md-12">
              <Input
                placeholder="e.g. Syphilis/IS"
                label={language[this.props.defaultLanguage].test_name}
                value={this.state.testName}
                onChange={(e) => this.onChangeText("testName", e)}
                error={this.state.error.testName}
              />
            </div>
            <div className="col-md-6">
              <Input
                type="number"
                step="0.01"
                placeholder="e.g. 1.0"
                label={language[this.props.defaultLanguage].reactive_cutoff}
                value={this.state.reactiveCutoff}
                onChange={(e) => this.onChangeText("reactiveCutoff", e)}
                error={this.state.error.reactiveCutoff}
              />
            </div>
            <div className="col-md-6">
              <Input
                type="number"
                step="0.01"
                placeholder="e.g. 0.9"
                label={language[this.props.defaultLanguage].gray_zone_cutoff}
                value={this.state.grayZoneCutoff}
                onChange={(e) => this.onChangeText("grayZoneCutoff", e)}
                error={this.state.error.grayZoneCutoff}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={YES_NO_OPTIONS}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].block_donor}
                value={this.state.blockDonor}
                onChange={(e) => this.onChangeText("blockDonor", e)}
                error={this.state.error.blockDonor}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={YES_NO_OPTIONS}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].block_donation}
                value={this.state.blockDonation}
                onChange={(e) => this.onChangeText("blockDonation", e)}
                error={this.state.error.blockDonation}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={YES_NO_OPTIONS}
                placeholder={language[this.props.defaultLanguage].select}
                label={
                  language[this.props.defaultLanguage].requires_confirmation
                }
                value={this.state.requiresConfirmation}
                onChange={(e) => this.onChangeText("requiresConfirmation", e)}
                error={this.state.error.requiresConfirmation}
              />
            </div>
            <div className="col-md-6">
              <Input
                placeholder="e.g. TPPA, Western Blot, PCR"
                label={language[this.props.defaultLanguage].confirmation_type}
                value={this.state.confirmationType}
                onChange={(e) => this.onChangeText("confirmationType", e)}
                error={this.state.error.confirmationType}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={YES_NO_OPTIONS}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].repeat_required}
                value={this.state.repeatRequired}
                onChange={(e) => this.onChangeText("repeatRequired", e)}
                error={this.state.error.repeatRequired}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={REPEAT_RULE_OPTIONS}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].repeat_rule}
                value={this.state.repeatRule}
                onChange={(e) => this.onChangeText("repeatRule", e)}
                error={this.state.error.repeatRule}
              />
            </div>
            <div className="col-md-12">
              <Input
                placeholder={
                  language[this.props.defaultLanguage]
                    .display_meaning_placeholder
                }
                label={language[this.props.defaultLanguage].display_meaning}
                value={this.state.displayMeaning}
                onChange={(e) => this.onChangeText("displayMeaning", e)}
                error={this.state.error.displayMeaning}
              />
            </div>
            <div className="col-md-12">
              <Input
                placeholder={
                  language[this.props.defaultLanguage].next_action_placeholder
                }
                label={language[this.props.defaultLanguage].next_action}
                value={this.state.nextAction}
                onChange={(e) => this.onChangeText("nextAction", e)}
                error={this.state.error.nextAction}
              />
            </div>
            {/* New outcome fields */}
            <div className="col-md-6">
              <Select
                options={RESULT_CONDITION_OPTIONS}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].result_condition}
                value={this.state.resultCondition}
                onChange={(e) => this.onChangeText("resultCondition", e)}
                error={this.state.error.resultCondition}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={DONATION_STATUS_OPTIONS}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].donation_status}
                value={this.state.donationStatus}
                onChange={(e) => this.onChangeText("donationStatus", e)}
                error={this.state.error.donationStatus}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={DONOR_STATUS_OPTIONS}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].donor_status}
                value={this.state.donorStatus}
                onChange={(e) => this.onChangeText("donorStatus", e)}
                error={this.state.error.donorStatus}
              />
            </div>
            <div className="col-md-6">
              <Input
                placeholder="e.g. Collect additional sample"
                label={language[this.props.defaultLanguage].action_required}
                value={this.state.actionRequired}
                onChange={(e) => this.onChangeText("actionRequired", e)}
                error={this.state.error.actionRequired}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={BLOCK_CLASSIFICATION_OPTIONS}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].block_classification}
                value={this.state.blockClassification}
                onChange={(e) => this.onChangeText("blockClassification", e)}
                error={this.state.error.blockClassification}
              />
            </div>
            <div className="col-md-6">
              <Input
                placeholder={
                  language[this.props.defaultLanguage].next_actions_placeholder
                }
                label={language[this.props.defaultLanguage].next_actions}
                value={this.state.nextActions}
                onChange={(e) => this.onChangeText("nextActions", e)}
                error={this.state.error.nextActions}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={YES_NO_OPTIONS}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].mandatory_actions}
                value={this.state.mandatoryActions}
                onChange={(e) => this.onChangeText("mandatoryActions", e)}
                error={this.state.error.mandatoryActions}
              />
            </div>
            {/* Blood-grouping-only fields */}
            {this.state.testType?.value === "bloodGrouping" && (
              <>
                <div className="col-md-6">
                  <Input
                    placeholder="e.g. ABO-DISCREPANCY"
                    label={
                      language[this.props.defaultLanguage].blood_group_scenario
                    }
                    value={this.state.bloodGroupScenario}
                    onChange={(e) =>
                      this.onChangeText("bloodGroupScenario", e)
                    }
                    error={this.state.error.bloodGroupScenario}
                  />
                </div>
                <div className="col-md-6">
                  <Select
                    options={YES_NO_OPTIONS}
                    placeholder={language[this.props.defaultLanguage].select}
                    label={
                      language[this.props.defaultLanguage].quarantine_donation
                    }
                    value={this.state.quarantineDonation}
                    onChange={(e) =>
                      this.onChangeText("quarantineDonation", e)
                    }
                    error={this.state.error.quarantineDonation}
                  />
                </div>
                <div className="col-md-6">
                  <Select
                    options={YES_NO_OPTIONS}
                    placeholder={language[this.props.defaultLanguage].select}
                    label={
                      language[this.props.defaultLanguage]
                        .requires_investigation
                    }
                    value={this.state.requiresInvestigation}
                    onChange={(e) =>
                      this.onChangeText("requiresInvestigation", e)
                    }
                    error={this.state.error.requiresInvestigation}
                  />
                </div>
                <div className="col-md-12">
                  <Input
                    placeholder={
                      language[this.props.defaultLanguage]
                        .product_restrictions_placeholder
                    }
                    label={
                      language[this.props.defaultLanguage].product_restrictions
                    }
                    value={this.state.productRestrictions}
                    onChange={(e) =>
                      this.onChangeText("productRestrictions", e)
                    }
                    error={this.state.error.productRestrictions}
                  />
                </div>
              </>
            )}
            <div className="col-md-6">
              <Input
                type="number"
                placeholder="e.g. 1"
                label={language[this.props.defaultLanguage].sort_order}
                value={this.state.sortOrder}
                onChange={(e) => this.onChangeText("sortOrder", e)}
                error={this.state.error.sortOrder}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={[
                  { label: "Active", value: true },
                  { label: "Inactive", value: false },
                ]}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].is_active}
                value={this.state.isActive}
                onChange={(e) => this.onChangeText("isActive", e)}
                error={this.state.error.isActive}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
            className="btn-default"
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            onPress={this.onSubmit.bind(this)}
            isSubmitting={this.state.isSubmitting}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return { defaultLanguage };
};

export default connect(mapStateToProps)(NewTestAssayRule);
